import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [], 
  selectedProject:{},
};

const projectSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setSelectedProjectData: (state, action) => {
      state.selectedProject = action.payload;
    },
    setProjectData: (state, action) => {
      state.value = action.payload;
    },
    addProjectData: (state, action) => {
      state.value.push(action.payload);
    },
    clearProjectData: (state) => {
      state.value = [];
    },
  },
});

export const { setSelectedProjectData,setProjectData, addProjectData, clearProjectData } =
  projectSlice.actions;

export default projectSlice.reducer;
